module.exports = __webpack_public_path__ + "static/snapshot.bb5b70c5.png";